{
  "wood-cancel-1": [
    0.0,
    0.6105442176870748
  ],
  "wood-cancel-2": [
    0.6605442176870748,
    0.29895691609977326
  ],
  "wood-confirm-1": [
    1.009501133786848,
    0.60140589569161
  ],
  "wood-cursor-1": [
    1.660907029478458,
    0.22929705215419502
  ],
  "wood-error-1": [
    1.9402040816326531,
    0.7596145124716553
  ],
  "wood-select-1": [
    2.7498185941043083,
    0.2632199546485261
  ],
  "table-deck-deal-1": [
    3.0630385487528344,
    0.7448072562358277
  ],
  "table-deck-deal-2": [
    3.857845804988662,
    0.6699319727891156
  ],
  "table-deck-shuffle-1": [
    4.5777777777777775,
    0.5792743764172336
  ],
  "table-deck-shuffle-2": [
    5.207052154195011,
    0.6547619047619048
  ],
  "table-dice-pickup-1": [
    5.911814058956916,
    0.5449206349206349
  ],
  "table-dice-pickup-2": [
    6.506734693877551,
    0.3613832199546485
  ],
  "table-dice-roll-1": [
    6.9181179138322,
    1.106485260770975
  ],
  "table-paper-flip-1": [
    8.074603174603174,
    0.5878004535147392
  ],
  "table-piece-impact-1": [
    8.712403628117913,
    0.2574149659863946
  ],
  "table-piece-impact-2": [
    9.019818594104308,
    0.2542857142857143
  ],
  "table-piece-move-1": [
    9.324104308390023,
    0.35052154195011337
  ],
  "table-piece-move-2": [
    9.724625850340136,
    0.43170068027210884
  ],
  "v1-card-place-1": [
    10.206326530612245,
    0.6891156462585034
  ],
  "v1-card-place-2": [
    10.945442176870749,
    0.45648526077097507
  ],
  "v1-card-place-4": [
    11.451927437641723,
    0.6007709750566893
  ],
  "v1-card-slide-2": [
    12.102698412698413,
    0.5840816326530612
  ],
  "v1-card-slide-3": [
    12.736780045351473,
    0.5981179138321996
  ],
  "v1-card-slide-4": [
    13.384897959183673,
    0.45650793650793653
  ],
  "v1-card-slide-5": [
    13.89140589569161,
    0.6007482993197278
  ],
  "v1-card-slide-6": [
    14.542154195011339,
    0.6007709750566893
  ],
  "v1-card-slide-7": [
    15.192925170068028,
    0.6361224489795918
  ],
  "v1-card-slide-8": [
    15.879047619047618,
    0.6714285714285714
  ]
}
